// extracted by mini-css-extract-plugin
export var divider = "_1x-0";
export var dividerText = "_1x-2";
export var dividerVertical = "_1x-1";